import React, { useState, useRef, useEffect, useCallback } from 'react';
import axios from 'axios';
import { Modal, Button, Form, FormGroup, FormControl } from 'react-bootstrap';
import authHeader from '../services/AuthHeader';
import SimpleReactValidator from 'simple-react-validator';
import _ from 'lodash';

const EditAdminModal = (props) => {
  let initValue = {
    starId: '',
    firstName: '',
    lastName: '',
    email: '',
  };

  const [user, setUser] = useState(initValue);
  const [hasChanged, setHasChanged] = useState(false);
  const [starId, setStarId] = useState();
  const [firstName, setFirstName] = useState();
  const [lastName, setLastName] = useState();
  const [email, setEmail] = useState();

  const simpleValidator = useRef(
    new SimpleReactValidator({ className: 'text-danger' })
  );
  const [showSubmit, setShowSubmit] = useState(true);
  let allValid = simpleValidator.current.allValid();

  /* set user for edit */
  useEffect(() => {
    setUser({
      starId: props.user.adminId,
      firstName: props.user.firstName,
      lastName: props.user.lastName,
      email: props.user.email,
    });
  }, [props.user]);

  useEffect(() => {
    if (allValid) {
      setShowSubmit(false);
    } else {
      setShowSubmit(true);
    }
  }, [allValid]);

  /* insert new admin or update existing on submit */
  const submitHandler = (e) => {
    e.preventDefault();

    async function doAction() {
      if (hasChanged === true) {
        /*put request when mode == "EDIT"*/
        if (props.mode === 'EDIT') {
          axios
            .put(
              process.env.REACT_APP_API_BASE + 'admin/' + props.user.adminId,
              user,
              { headers: authHeader() }
            )
            .then((res) => props.setRerender(true));
        }
        /*post request when mode == "ADD"*/

        if (props.mode === 'ADD') {
          axios
            .post(process.env.REACT_APP_API_BASE + 'admin/', user, {
              headers: authHeader(),
            })
            .then((res) => props.setRerender(true));
        }
      }

      setHasChanged(false);
      setUser(initValue);
      setStarId('');
      setFirstName('');
      setLastName('');
      setEmail('');
    }
    doAction();
  };

  const handleChangeStarId = function (e) {
    debounceCandidates(e);
  };

  /* get admin details using StarId to fill in form */
  const debounceCandidates = useCallback(
    _.debounce((e) => {
      const { value } = e.target;
      axios
        .get(process.env.REACT_APP_API_BASE + 'PersonInfo/' + value, {
          headers: authHeader(),
        })
        .then((res) => {
          if (res.data) {
            setFirstName(res.data.first_Name);
            setLastName(res.data.last_Name);
            setEmail(res.data.email);
            setUser({
              starId: value,
              firstName: res.data.first_Name,
              lastName: res.data.last_Name,
              email: res.data.email,
            });
          }
        });
    }, 1000),
    []
  );

  /* if any values are manually changed */
  const handleChange = function (varName, e) {
    setHasChanged(true);
    const { value } = e.target;
    setUser((state) => ({ ...state, [varName]: value }));
  };

  /* set user and close modal */
  const handleClick = function () {
    setHasChanged(true);
    setUser((state) => ({ ...state }));
    props.onHide();
  };

  /* clears modal and close */
  const handleBack = function () {
    setStarId('');
    setFirstName('');
    setLastName('');
    setEmail('');
    setUser(initValue);
    props.onHide();
  };

  let cStarId = '';
  let cFirstName = '';
  let cLastName = '';
  let cEmail = '';
  let cParam = '';
  if (props.mode === 'ADD') {
    cStarId = user.starId;
    cFirstName = user.firstName;
    cLastName = user.lastName;
    cEmail = user.email;
    cParam = 'alpha_num';
  } else {
    cStarId = user.starId;
    cFirstName = user.firstName;
    cLastName = user.lastName;
    cEmail = user.email;
    cParam = 'alpha_num';
  }
  const { setRerenderListings, ...modalProps } = props;
  return (
    <Modal
      {...modalProps}
      size='lg'
      aria-labelledby='contained-modal-title-vcenter'
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id='contained-modal-title-vcenter'></Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={submitHandler}>
          <FormGroup controlId='starId'>
            <FormControl
              placeholder='Star Id'
              defaultValue={props.user.starId}
              aria-label='Admin Star ID'
              onChange={(e) => handleChangeStarId(e)}
              autoComplete='off'
              name='starId'
              onBlur={simpleValidator.current.showMessageFor('starId')}
            />
            {simpleValidator.current.message('starId', cStarId, cParam)}
          </FormGroup>
          <FormGroup controlId='firstName'>
            <FormControl
              placeholder='First Name'
              defaultValue={firstName}
              aria-label='Admin first name'
              onChange={(e) => handleChange('firstName', e)}
              autoComplete='off'
              name='firstName'
              onBlur={simpleValidator.current.showMessageFor('firstName')}
            />
            {simpleValidator.current.message(
              'firstName',
              cFirstName,
              'alpha_space'
            )}
          </FormGroup>
          <FormGroup controlId='lastName'>
            <FormControl
              placeholder='Last Name'
              defaultValue={lastName}
              aria-label='Admin last name'
              onChange={(e) => handleChange('lastName', e)}
              autoComplete='off'
              name='lastName'
              onBlur={simpleValidator.current.showMessageFor('lastName')}
            />
            {simpleValidator.current.message(
              'lastName',
              cLastName,
              'alpha_space'
            )}
          </FormGroup>
          <FormGroup controlId='email'>
            <FormControl
              placeholder='Email'
              defaultValue={email}
              aria-label='Admin email'
              onChange={(e) => handleChange('email', e)}
              autoComplete='off'
              name='email'
              onBlur={simpleValidator.current.showMessageFor('email')}
            />
            {simpleValidator.current.message('email', cEmail, 'email')}
          </FormGroup>
          <Button
            className='btn btn-default'
            type='submit'
            onClick={handleClick}
            disabled={showSubmit}
          >
            Save
          </Button>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={handleBack}>Back</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditAdminModal;
